import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import PermitsCloseOut from 'src/pages/Permits/TreePermit/PermitsCloseOut';
import {
  canAccessPermitCloseOut,
  getPermitFeatureDeniedRedirect,
  isPermitFeatureTownshipAllowed
} from 'src/utils/permitFeatureAccess';

const PermitCloseOutRoute = () => {
  const { townshipId, permit } = useParams<{ townshipId: string; permit: string }>();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);

  if (!canAccessPermitCloseOut(userDetails, Number(permit))) {
    return (
      <Navigate
        to={getPermitFeatureDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  if (!isPermitFeatureTownshipAllowed(userDetails, townshipId)) {
    return (
      <Navigate
        to={getPermitFeatureDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  return <PermitsCloseOut />;
};

export default PermitCloseOutRoute;
